module.exports = __webpack_public_path__ + "static/media/threed-bg.991c1b23.jpeg";